import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { CommissionCashbackMutationKeys } from '../../../keys'
import { deleteCommissionCashback } from '../../services'

interface UseMutationDeleteCommissionProps {
	id: string
}

export default function useMutationDeleteCommission(
	props?: UseBaseMutationOptions<void, UseMutationDeleteCommissionProps>,
) {
	return useMutation({
		mutationKey: [CommissionCashbackMutationKeys.DeleteCommissionCashback],
		mutationFn: ({ id }) => deleteCommissionCashback(id),
		...props,
	})
}
